// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35za2","col":"styles_col__1eTWy"};